import { create } from "zustand";

interface ISubOption { 
    [key : string] : {value : string, label : string}[]
 }

 interface IRawParam { name : string, value : string, label : string}

interface resortState {
    isMenuOpen : boolean
    toggleMenuOpen : () => void
    closeMenuOpen : () => void
    openSubMenuIndex : number
    setOpenSubMenuIndex : ( index : number ) => void
    closeSubMenu : () => void
    stringParams : string[],
    params : ISubOption[],
    setParams : (param : IRawParam) => void
    clearParams : () => void
    isInParams : (item : string) => boolean
    selectedDestinationGlobal : string
    setSelectedDestinationGlobal : (destiny : string) => void
}

const reduceFn = (stateParam : ISubOption[], name : string, paramInput : IRawParam) => {
    
    const { name : nameInput, value, label } = paramInput
    const newValueObj = {value : value, label : label }
    let theRetData : ISubOption = { [name] : [{value : value, label : label }] }

    const isAvail = stateParam.findIndex(  obj => Object.keys(obj)[0] == name ) 

    if ( isAvail == -1) {
        console.log('not yet available', stateParam)
        console.log('not yet available', theRetData)

        const newRetData = [ ...stateParam, theRetData ]
        return newRetData

    } else {
        
        // prop exists already
        const currentFilterValues = stateParam[isAvail][name]
        const isAlreadyInside = currentFilterValues.find( item => item.value == value )
        
        let newValue = []
        if (isAlreadyInside) {
            newValue = currentFilterValues.filter( item => item.value != value  )
        } else {
            newValue = [ ...currentFilterValues, ...theRetData[name] ]
        }

        stateParam[isAvail] = {
            [name] :   newValue
        }

        const filterOptions = stateParam.filter( opts => opts[Object.keys(opts)[0]].length != 0  )
        console.log('WAT',filterOptions)

        return filterOptions
    }

}

const reduceToStrings = (filterOptions : ISubOption[]) => {

    const toStringParams = filterOptions
    .flatMap( item => item[Object.keys(item)[0]] )
    .map( item => item.value )

    return toStringParams
}

export const useResortMenuStore = create<resortState>((set,get) => ({
    isMenuOpen : false,
    toggleMenuOpen : () => { 
        set( ( state ) => ({ isMenuOpen : !state.isMenuOpen }) ) 
    },
    closeMenuOpen : () => { set( state => ({isMenuOpen : false}) ) },
    openSubMenuIndex : -1,
    setOpenSubMenuIndex : (index : number) => set( { openSubMenuIndex : index } ),
    closeSubMenu : () => set( { openSubMenuIndex : -1 } ),
    stringParams : [],
    params : [],
    setParams : ( newparam : IRawParam ) => {
        const { name, value, label } = newparam;
        let prevParams = get().params
        const reduceFNValue = reduceFn(prevParams, name, newparam)
        reduceFNValue && set( state => ( { params : [ ...reduceFNValue ] } ) )
        get().params && set( state => ({ stringParams : reduceToStrings(get().params) })) 
    },
    clearParams : () => {
        set( state => ({ stringParams : [] }) )
        set( state => ({ params : [] }) )
    },
    isInParams : (item : any) => { 
        if ( get().stringParams.includes(item) ) {
            return true 
        }
        else {
            return false
        }
        
    },
    selectedDestinationGlobal : '',
    setSelectedDestinationGlobal : ( destiny : string ) => { set( (state) => ({ selectedDestinationGlobal : destiny }) ) }
    
}))